// extracted by mini-css-extract-plugin
export var orderSummary = "_qe-0";
export var showMoreLessButton = "_qe-1";